/** Zona horaria oficial para programación D28D (clases en vivo, calendario, Zoom). */
export const D28D_SCHEDULE_TZ = 'America/Bogota';

function formatToPartsInTz(date, timeZone = D28D_SCHEDULE_TZ) {
  const fmt = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  const parts = {};
  for (const p of fmt.formatToParts(date)) {
    if (p.type !== 'literal') parts[p.type] = p.value;
  }
  if (parts.hour === '24') parts.hour = '00';
  return parts;
}

/** ISO UTC → YYYY-MM-DDTHH:mm en hora D28D (Bogotá). */
export function formatDateTimeInScheduleTz(value, timeZone = D28D_SCHEDULE_TZ) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) {
    const raw = String(value).replace('Z', '').slice(0, 16);
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(raw)) return raw.slice(0, 16);
    return '';
  }
  const p = formatToPartsInTz(d, timeZone);
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
}

/** datetime-local (hora D28D) → ISO UTC para API. */
export function scheduleTzLocalToUtcIso(localValue, timeZone = D28D_SCHEDULE_TZ) {
  const m = String(localValue).match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
  if (!m) return '';
  const ty = +m[1];
  const tmo = +m[2];
  const td = +m[3];
  const th = +m[4];
  const tmi = +m[5];

  let utc = Date.UTC(ty, tmo - 1, td, th, tmi);
  for (let i = 0; i < 8; i += 1) {
    const p = formatToPartsInTz(new Date(utc), timeZone);
    const dd = td - +p.day;
    const dh = th - +p.hour;
    const dmi = tmi - +p.minute;
    const dmo = tmo - +p.month;
    const dy = ty - +p.year;
    if (dy === 0 && dmo === 0 && dd === 0 && dh === 0 && dmi === 0) {
      return new Date(utc).toISOString();
    }
    utc += (((dy * 31 + dmo) * 31 + dd) * 24 + dh) * 60 * 60 * 1000 + dmi * 60 * 1000;
  }
  return new Date(utc).toISOString();
}

export function timeFromIsoInScheduleTz(iso, lang = 'es', timeZone = D28D_SCHEDULE_TZ) {
  try {
    const locale = lang === 'en' ? 'en-US' : 'es-CO';
    return new Intl.DateTimeFormat(locale, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone,
    }).format(new Date(iso));
  } catch {
    return '';
  }
}

export function dateKeyInScheduleTz(iso, timeZone = D28D_SCHEDULE_TZ) {
  try {
    return new Intl.DateTimeFormat('en-CA', { timeZone }).format(new Date(iso));
  } catch {
    return '';
  }
}

export function hourInScheduleTz(iso, timeZone = D28D_SCHEDULE_TZ) {
  const p = formatToPartsInTz(new Date(iso), timeZone);
  return Number(p.hour);
}

export function sameScheduleDay(iso, dayDate, timeZone = D28D_SCHEDULE_TZ) {
  const key = dateKeyInScheduleTz(iso, timeZone);
  if (!key || !dayDate) return false;
  const y = dayDate.getFullYear();
  const m = String(dayDate.getMonth() + 1).padStart(2, '0');
  const d = String(dayDate.getDate()).padStart(2, '0');
  return key === `${y}-${m}-${d}`;
}
